"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutKanbanAside = exports.LayoutKanbanMain = exports.LayoutKanbanHeader = exports.LayoutKanban = void 0;
var kanban_1 = require("./kanban/kanban");
Object.defineProperty(exports, "LayoutKanban", { enumerable: true, get: function () { return __importDefault(kanban_1).default; } });
var kanban_header_1 = require("./kanban/kanban.header");
Object.defineProperty(exports, "LayoutKanbanHeader", { enumerable: true, get: function () { return __importDefault(kanban_header_1).default; } });
var kanban_main_1 = require("./kanban/kanban.main");
Object.defineProperty(exports, "LayoutKanbanMain", { enumerable: true, get: function () { return __importDefault(kanban_main_1).default; } });
var kanban_aside_1 = require("./kanban/kanban.aside");
Object.defineProperty(exports, "LayoutKanbanAside", { enumerable: true, get: function () { return __importDefault(kanban_aside_1).default; } });
//# sourceMappingURL=index.js.map